import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addStockToLocationModalTitle: {
    description: 'Add to alternate location warehouse modal title',
    defaultMessage: 'Add Stock to Location',
    id: 'TyMbRd',
  },
  alternateLocationModalCancel: {
    description: 'Add to alternate location cancel button',
    defaultMessage: 'Cancel',
    id: 'R23q4Z',
  },
  alternateLocationModalAddLocation: {
    description: 'Add to alternate location add location button',
    defaultMessage: 'Add Stock',
    id: 'RNp4+g',
  },
  addToLocationLocationNameLabel: {
    description: 'Add to alternate location name label',
    defaultMessage: 'Product Name',
    id: 'gbEVud',
  },
  addToLocationLocationSkuLabel: {
    description: 'Add to alternate location sku label',
    defaultMessage: 'Product SKU',
    id: 'Ivqdaw',
  },
});
